import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { LeafElement } from "../../components/leaf-element.js";
const styles = '/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  display: block;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :host {\n    --scroll-section-duration: 0.6s;\n  }\n  :host .chc-c-scroll-section {\n    height: 100%;\n    position: relative;\n    width: 100%;\n  }\n  :host slot[name=beginning],\n  :host slot[name=middle],\n  :host slot[name=end] {\n    display: block;\n    opacity: 0;\n    transition: opacity var(--scroll-section-duration);\n  }\n  :host slot[name=beginning],\n  :host slot[name=middle] {\n    position: absolute;\n  }\n  :host slot[name=end] {\n    position: relative;\n  }\n  :host([show]) slot[name=beginning],\n  :host([show]) slot[name=middle],\n  :host([show]) slot[name=end] {\n    opacity: 1;\n  }\n  :host([show][steps="2"]) slot[name=end] {\n    transition-delay: var(--scroll-section-duration);\n  }\n  :host([show][steps="3"]) slot[name=middle] {\n    transition-delay: var(--scroll-section-duration);\n  }\n  :host([show][steps="3"]) slot[name=end] {\n    transition-delay: calc(var(--scroll-section-duration) * 2);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  :host ::slotted([slot=beginning]),\n  :host ::slotted([slot=middle]) {\n    display: none;\n  }\n  :host slot[name=end] {\n    opacity: 1;\n  }\n}';
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _CHCScrollSection = class _CHCScrollSection extends LeafElement {
  constructor() {
    super(...arguments);
    this.steps = "2";
    this.show = false;
  }
  get animatedSlots() {
    return this.querySelectorAll('[slot="beginning"], [slot="middle"]');
  }
  async firstUpdated() {
    await this.updateComplete;
    this.animatedSlots.forEach((slot) => slot.setAttribute("aria-hidden", "true"));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0 && !this.show) {
            this.show = true;
          }
        });
      },
      { threshold: 0.9 }
    );
    observer.observe(this);
  }
  render() {
    return html`<div class="chc-c-scroll-section">
      <slot name="beginning"></slot>
      <slot name="middle"></slot>
      <slot name="end"></slot>
    </div>`;
  }
};
_CHCScrollSection.styles = unsafeCSS(styles);
let CHCScrollSection = _CHCScrollSection;
__decorateClass([
  property({ reflect: true })
], CHCScrollSection.prototype, "steps", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], CHCScrollSection.prototype, "show", 2);
export {
  CHCScrollSection
};
//# sourceMappingURL=scroll-section.component.js.map
